// 只选择组件语言包；日期、优惠等函数保留原对象，不做字符串化或全局文本转换。
export const selectComponentLocale = (
  locale,
  simplified,
  english,
  traditional
) =>
  locale === "en-US" ? english : locale === "zh-HK" ? traditional : simplified;
